<template>
  <div class="dados-sanguineos-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form>
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-select
              v-model="fields.tipoSangue"
              item-text="label"
              item-value="value"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :items="bloodTypes"
              :label="$t('Tipo_Sangue')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-switch
              v-model="fields.aceitaTransfusaoSangue"
              inset
              :label="$t('Aceita_Transfusao_Sangue')"
              class="ma-0 pa-0 pt-2"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-switch
              v-model="fields.doadorOrgaos"
              inset
              :label="$t('Doador_Orgaos')"
              class="ma-0 pa-0 pt-2"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-switch
              v-model="fields.usaMedicacaoAntiCoagulo"
              inset
              :label="$t('medicacao_anti_coagulo')"
              class="ma-0 pa-0 pt-2"
            />
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { updateData } from "@/services";
export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm },
  data: () => ({
    fields: {
      tipoSangue: null,
      aceitaTransfusaoSangue: false,
      doadorOrgaos: false,
      usaMedicacaoAntiCoagulo: false,
    },
    bloodTypes: [
      { label: "", value: null },
      { label: "A  +", value: "A+" },
      { label: "A  -", value: "A-" },
      { label: "B  +", value: "B+" },
      { label: "B  -", value: "B-" },
      { label: "AB +", value: "AB+" },
      { label: "AB -", value: "AB-" },
      { label: "O  +", value: "O+" },
      { label: "O  -", value: "O-" },
    ],
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);
  },
  methods: {
    onSave() {
      updateData(this, "tagFuncionario", this.fields);
    },
  },
};
</script>

<style scoped></style>
